import {
  FETCH_BLOGS_SUCCESS,
} from "../constants/action-types";

const initialState = []

export default function blogReducer(state = initialState, action) {
  switch (action.type) {
    // sets the blogs array
    case FETCH_BLOGS_SUCCESS:
      return action.payload.blogs
    default:
      return state;
  }
}
